import { css } from '@emotion/core';

export const PTSans = css`
  font-family: 'PT Sans', sans-serif;
  font-weight: normal;
`;

export const PTMono = css`
  font-family: 'PT Mono', monospace;
  font-weight: normal;
`;

export const PTBold = css`
  font-family: 'PT Mono', monospace;
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/components/styles/fonts.js